import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

const BulkCreateRowSchema_ = z.object({
  teamName: z.string(),
  storeUrl: z.string(),
  websiteDomain: z.string().optional(),
});
export interface BulkCreateRowSchema extends z.infer<
  typeof BulkCreateRowSchema_
> {}
export const BulkCreateRowSchema: z.ZodType<BulkCreateRowSchema> =
  BulkCreateRowSchema_;

export const BulkCreateResultSchema_ = z.object({
  teamName: z.string(),
  storeUrl: z.string(),
  status: z.enum(["created", "skipped", "error"]),
  teamId: z.string().nullable(),
  message: z.string().nullable(),
  onboardingStatus: z.enum(["running", "completed", "failed"]).nullable(),
});
export interface BulkCreateResultSchema extends z.infer<
  typeof BulkCreateResultSchema_
> {}
export const BulkCreateResultSchema: z.ZodType<BulkCreateResultSchema> =
  BulkCreateResultSchema_;

export const bulkCreateAeoProspects = unaryRpc({
  name: "bulkCreateAeoProspects",
  input: z.object({ rows: z.array(BulkCreateRowSchema) }),
  output: z.object({
    results: z.array(BulkCreateResultSchema),
    summary: z.object({
      created: z.number(),
      skipped: z.number(),
      errored: z.number(),
    }),
  }),
});
